export default "__VITE_PUBLIC_ASSET__a70fbae2__"